import { type MutableRefObject, useEffect } from 'react';
import type { Object3D } from 'three';
import { useEditorStore } from 'modules/editor/store';

export const useStaticSize = (ref: MutableRefObject<Object3D | null>) => {
  useEffect(
    () =>
      useEditorStore.subscribe(
        (state) => state.scaleFactor,
        (scaleFactor) => void ref.current?.scale.set(scaleFactor, scaleFactor, 1),
        { fireImmediately: true }
      ),
    [ref]
  );
};
